import odata from '@/core/api/mixin/odata'
import rest from '@/core/api/mixin/rest'
import { apiClient } from '@/core/api/httpClient'

export default {
  ...odata('roles'),
  ...rest('roles'),
  getById: function (id) {
    return apiClient.get(`/roles/${id}`, {
      params: {
        relations: 'acl_entities',
      },
    })
  },
}
